import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomSlider from "../section/CustomSlider";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Login() {
    const { t } = useTranslation();

    // Function to show the toast notification
    const handleLogin = (event) => {
        event.preventDefault(); // Prevent form submission
        
        // Show the toast notification
        toast.success(t("Login Successful"), {
            position: "top-left", // Correct usage of positioning
            autoClose: 2000, // Set custom time (2000ms)
        });
    };

    return (
        <>
            {/* Toast Container for displaying the toast messages */}
            <ToastContainer />

            <section className="relative h-[100vh]">
                <div className="container h-full flex justify-between items-center">
                    <div className="w-[45%] flex flex-col gap-[40px]">
                        <div>
                            <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                        </div>
                        <div className="flex flex-col text-[#09778E] font-bold text-[30px]">
                            <div>{t("Welcome Back !")}</div>
                            <div>{t("to Academix Learning Platform")}</div>
                        </div>
                        <div>
                            <CustomSlider />
                        </div>
                    </div>
                    <div className="w-[5%]">
                        <img className="h-[650px]" src={require("../../assets/icons/rigister-line.svg").default} alt="" />
                    </div>
                    <div className="w-[45%] flex flex-col justify-between gap-[50px]">
                        <div className="flex items-center text-center flex-col gap-[8px] justify-center">
                            <div className="flex flex-col text-[#09778E] font-bold text-[30px]">{t("Login Now !")}</div>
                            <div className="flex items-center gap-[12px]">
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                                <div className="text-[#5D5A6F] flex items-center gap-[5px]">
                                    {t("Don't have an account?")} <Link to={"/user-type"} className="text-[#09758b]">{t("Create an account")}</Link>
                                </div>
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                            </div>
                        </div>
                        <form onSubmit={handleLogin}> {/* Attach handleLogin to the form submission */}
                            <div className="flex flex-col gap-[8px]">
                                <div className="flex flex-col gap-[25px]">
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Phone Number")}</label>
                                        <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder="Your Phone Number" />
                                    </div>
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Your Password")}</label>
                                        <input type="password" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder="Your Password" />
                                    </div>
                                    <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">{t("Login in")}</button>
                                </div>
                                <div className="flex items-center justify-between">
                                    <div></div>
                                    <Link to={"/forgot"} className="text-[#09758b]">{t("Forgot Password?")}</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}
